var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchivar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "archive_FILL0_wght300_GRAD0_opsz40",
    d: "M146-815.386a.425.425,0,0,0-.315.127.432.432,0,0,0-.126.316v2.982l-1.192-1.192a.421.421,0,0,0-.3-.124.4.4,0,0,0-.3.122.4.4,0,0,0-.127.3.423.423,0,0,0,.127.308l1.854,1.854a.532.532,0,0,0,.387.165.529.529,0,0,0,.386-.165l1.854-1.854a.421.421,0,0,0,.124-.3.4.4,0,0,0-.122-.3.4.4,0,0,0-.3-.127.423.423,0,0,0-.308.127l-1.192,1.192v-2.982a.428.428,0,0,0-.128-.316A.432.432,0,0,0,146-815.386Zm-5.111-1.8v8.079a.211.211,0,0,0,.061.156.211.211,0,0,0,.156.061H150.9a.211.211,0,0,0,.156-.061.211.211,0,0,0,.061-.156v-8.079Zm.272,9.183a1.109,1.109,0,0,1-.806-.352,1.109,1.109,0,0,1-.352-.806v-8.453a1.118,1.118,0,0,1,.06-.362,1.051,1.051,0,0,1,.179-.323l1.01-1.285a1.021,1.021,0,0,1,.378-.307,1.106,1.106,0,0,1,.488-.112h7.751a1.128,1.128,0,0,1,.491.112,1.015,1.015,0,0,1,.381.307l1.024,1.3a1.043,1.043,0,0,1,.179.326,1.149,1.149,0,0,1,.06.366v8.433a1.109,1.109,0,0,1-.352.806,1.109,1.109,0,0,1-.806.352Zm.011-10.07h9.642l-.79-.969a.269.269,0,0,0-.078-.054.217.217,0,0,0-.092-.02h-7.724a.232.232,0,0,0-.094.02.21.21,0,0,0-.076.054ZM146-813.034Z",
    transform: "translate(-140.001 819.999)",
    fill: "#ead409"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivar);
export default __webpack_public_path__ + "static/media/archivar.18d9de9d3c78b22c1ac734cb48011b7c.svg";
export { ForwardRef as ReactComponent };